import * as SlotFamilyType from '../../../constants/SlotFamilyType';
export default function slotIdProvider(slotType, slotFamily, outcome) {
    var id = outcome.get('id');
    var conditionOne = outcome.get('condition');
    var playerId = outcome.get('playerId');
    switch (slotFamily) {
        case SlotFamilyType.TWO_WAY:
        case SlotFamilyType.THREE_WAY:
        case SlotFamilyType.MORE_THAN_X_GOALS:
        case SlotFamilyType.TENNIS_CORRECT_SCORE_WITH_CONDITION:
            return "".concat(slotType, "_").concat(id);
        case SlotFamilyType.TOTAL:
            if (playerId !== undefined && playerId !== null) {
                return "".concat(slotType, "_").concat(playerId, "_").concat(conditionOne);
            }
            return "".concat(slotType);
        default:
            return "".concat(slotType);
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/providers/SlotIdProvider.js